import { Plus, Trash2 } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

const num = (v) => (v === "" ? 0 : Number(v));
const VAL = [["any", "صالح أو غير صالح"], ["valid", "أداء صالح"], ["invalid", "أداء غير صالح"]];
const sel = "h-8 rounded-md border border-slate-200 bg-white px-1 text-xs";

const Formula = ({ f, i, set, del }) => (
  <div className="space-y-3 rounded-2xl border border-indigo-100 bg-indigo-50/40 p-4 text-xs" data-testid={`kf-row-${i}`}>
    <div className="flex items-center gap-2">
      <span className="font-bold text-indigo-800">صيغة {i + 1}</span>
      <select className={sel} value={f.validity || "any"} onChange={(e) => set({ validity: e.target.value })} data-testid={`kf-validity-${i}`}>
        {VAL.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <button onClick={del} className="ms-auto text-red-500" data-testid={`kf-del-${i}`}><Trash2 className="h-4 w-4" /></button>
    </div>
    <div className="grid grid-cols-4 gap-2">
      {[["from_orders", "من طلب", "0"], ["to_orders", "حتى طلب", "∞"], ["salary", "الراتب", "0"], ["per_order", Number(f.salary) ? "سعر الزيادة" : "سعر الطلب", "0"]].map(([key, l, ph]) => (
        <div key={key} className="min-w-0"><label className="mb-1 block text-[11px] font-semibold leading-tight text-slate-600">{l}</label>
          <Input type="number" step={key === "per_order" ? "0.1" : "1"} className="h-10 px-2 text-center text-sm" placeholder={ph} value={f[key] ?? ""}
            onChange={(e) => set({ [key]: e.target.value === "" ? (key === "to_orders" ? null : 0) : num(e.target.value) })} data-testid={`kf-${{ from_orders: "from", to_orders: "to", salary: "salary", per_order: "per" }[key]}-${i}`} /></div>
      ))}
    </div>
    <p className="text-[10px] text-slate-500">{Number(f.salary) ? `= ${f.salary} + (الطلبات − ${f.from_orders || 0}) × ${f.per_order || 0}` : `= عدد الطلبات × ${f.per_order || 0}`}</p>
  </div>
);

export const KeetaFormulasBox = ({ rules, onChange }) => {
  const rs = rules || [];
  return (
    <div className="space-y-2" data-testid="keeta-formulas-box">
      {rs.map((f, i) => <Formula key={i} f={f} i={i} set={(p) => onChange(rs.map((x, j) => (j === i ? { ...x, ...p } : x)))} del={() => onChange(rs.filter((_, j) => j !== i))} />)}
      <Button size="sm" variant="outline" className="gap-1" onClick={() => onChange([...rs, { validity: "any", from_orders: 0, to_orders: null, salary: 0, per_order: 0 }])} data-testid="kf-add"><Plus className="h-4 w-4" /> أضف صيغة</Button>
      <p className="text-[11px] leading-relaxed text-slate-500">«صالح» = الورديات الصالحة تساوي الورديات المجدولة في تقرير الصلاحية. عند انطباق أكثر من صيغة تُقدَّم الصيغة الخاصة بالصلاحية ثم الأعلى «من طلب».</p>
    </div>
  );
};

const GRADES = ["A", "B", "C", "D", "F"];
export const KeetaGradeFaceBox = ({ k, up }) => (
  <div className="space-y-3 rounded-xl border border-orange-100 bg-orange-50/40 p-3" data-testid="keeta-grade-face-box">
    <p className="text-sm font-bold text-orange-700">خصم التقييم (من تقرير الكاتقري)</p>
    <div className="grid grid-cols-5 gap-2">
      {GRADES.map((g) => (
        <div key={g}><label className="mb-1 block text-center text-xs font-bold">{g}</label>
          <Input type="number" className="h-8 text-center" value={(k.grade_fines || {})[g] ?? 0} onChange={(e) => up("grade_fines", { ...(k.grade_fines || {}), [g]: num(e.target.value) })} data-testid={`kg-fine-${g}`} /></div>
      ))}
    </div>
    <div className="flex flex-wrap items-center gap-2 text-xs">
      <span className="font-bold text-orange-700">عدم تطابق Face ID:</span>
      <Input type="number" className="h-8 w-20" value={k.face_fine ?? 100} onChange={(e) => up("face_fine", num(e.target.value))} data-testid="kg-face-fine" /><span>ريال ×</span>
      <select className={sel} value={k.face_mode || "fail"} onChange={(e) => up("face_mode", e.target.value)} data-testid="kg-face-mode">
        <option value="fail">عدد مرات Fail</option><option value="fail_expired">Fail + Expired</option><option value="days">عدد أيام الفشل</option>
      </select>
    </div>
  </div>
);
